import React, { useState } from 'react';
import { getProduct } from '../selectors';
import { useSelector, useDispatch } from 'react-redux';
import {
    Card,
    CardHeader,
    Typography,
    CardContent,
    IconButton,
} from '@material-ui/core';
import NumberSelector from './NumberSelector';
import { useEffect } from 'react';
import useDebounce from '../hooks/useDebounce';
import { changeAmount } from '../actions/cartActions';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Link } from 'react-router-dom';
import useDidMountEffect from '../hooks/useDidMountEffect';

const CartItem = ({ sku, amount }) => {
    const product = useSelector((state) => getProduct(state, sku));
    const [number, setNumber] = useState(amount);
    const debouncedNumber = useDebounce(number, 500);

    const dispatch = useDispatch();
    useDidMountEffect(() => {
        dispatch(changeAmount(sku, debouncedNumber));
    }, [debouncedNumber]);

    const handleDelete = () => {
        dispatch(changeAmount(sku, 0));
    };

    return product ? (
        <Card
            style={{
                marginBottom: '1rem',
                boxShadow: 'none',
                borderRadius: '1rem',
                width: '100%',
            }}
        >
            <CardContent
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 0,
                    width: '100%',
                }}
            >
                <img
                    style={{ width: '5rem' }}
                    alt={product.name}
                    src="https://firebasestorage.googleapis.com/v0/b/windsor-liquor.appspot.com/o/Liquors%2Fwine.png?alt=media"
                />
                <div style={{ marginRight: '1rem', width: '100%' }}>
                    <Link
                        style={{
                            textDecoration: 'none',
                        }}
                        to={`/liquors/${product.sku}`}
                    >
                        <Typography
                            style={{ textTransform: 'capitalize' }}
                            variant="h5"
                        >
                            {product.name}
                        </Typography>
                    </Link>
                    <div
                        style={{
                            marginTop: '1.3rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <NumberSelector
                                number={number}
                                setNumber={setNumber}
                            />

                            <IconButton
                                style={{ padding: 0, marginLeft: '.5rem' }}
                                onClick={handleDelete}
                            >
                                <DeleteForeverIcon />
                            </IconButton>
                        </div>
                        <Typography
                            style={{
                                fontWeight: '700',
                                marginLeft: '.5rem',
                                fontSize: '1.1rem',
                            }}
                        >
                            ${product.salePrice}
                        </Typography>
                    </div>
                </div>
            </CardContent>
        </Card>
    ) : null;
};

export default CartItem;
